import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {

    @Input('title') title: string = "";
    @Input('description') description: string = "";

    constructor() { }

    ngOnInit(): void {
    }

    onClose() {
        console.log("close");
    }

    onUndo() {
        console.log("undo");
    }

}
